import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useAuthStore } from '@/stores';
import { checkAuthStatus } from '@/lib/auth-client';
import { ThemeProvider } from '@/lib/theme-provider';
import Home from '@/pages/Home';
import Admin from '@/pages/Admin';
import Settings from '@/pages/Settings';
import Tasks from '@/pages/Tasks';
import Login from '@/pages/Login';
import SharedDocument from '@/pages/SharedDocument';
import { ApiKeysPage } from '@/pages/ApiKeys';

function App() {
  const { setUser, isLoading, isAuthenticated } = useAuthStore();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    checkAuthStatus()
      .then(({ user }) => {
        if (user) {
          setUser(user);
        }
      })
      .finally(() => {
        setAuthChecked(true);
      });
  }, [setUser]);

  if (!authChecked || isLoading) {
    return (
      <ThemeProvider>
        <div className="min-h-screen flex items-center justify-center bg-background">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <Routes>
        <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/" />} />
        <Route path="/shared/:token" element={<SharedDocument />} />
        <Route path="/admin" element={isAuthenticated ? <Admin /> : <Navigate to="/login" />} />
        <Route path="/settings" element={isAuthenticated ? <Settings /> : <Navigate to="/login" />} />
        <Route path="/tasks" element={isAuthenticated ? <Tasks /> : <Navigate to="/login" />} />
        <Route path="/api-keys" element={isAuthenticated ? <ApiKeysPage /> : <Navigate to="/login" />} />
        <Route path="/" element={isAuthenticated ? <Home /> : <Navigate to="/login" />} />
      </Routes>
      <Toaster position="bottom-right" />
    </ThemeProvider>
  );
}

export default App;